<app-loading-spinner *ngIf="appService.isLoading"></app-loading-spinner>

<div class="contact-container body-content-area">
    <div class="action-area">
        <div class="breadcrumb-area left-align">
            <p><a routerLink="/home"><u>Home</u> </a><span> > </span>
                <a routerLink="/home/carrier"><u>Carrier</u> </a><span> > </span>
                <span class="heading"> {{operation}} Carrier</span> 
                @if (operation!=='add') {
                    <span class="heading">({{dataSource.Name}})</span>
                }
            </p>
        </div>
        <div class="header-area left-align btn-container">
            @if (operation!=='add') {
                <span class="sub-title">({{dataSource.Name}})</span>
            }
            @else {
                <span class="sub-title">New Carrier</span>
            }
            <div class="action-bts">
                <button mat-button-primary class="btn white-red-btn" (click)="onbackCall()">Back</button>
                @if (operation!=='view') {
                    @if(operation !="add" && dataSource.Status!== 'Terminated'){
                        <button class="btn white-red-btn" *ngIf="dataSource.Status === 'Not Active'" [ngClass]="carrierForm.invalid?'disable-btn':'enable-btn'" (click)="onDelete()">Delete</button>
                        <button class="btn white-red-btn" [ngClass]="carrierForm.invalid?'disable-btn':'enable-btn'" (click)="onCopy()">Copy</button>
                    }
                    <button class="btn red-white-btn" [ngClass]="carrierForm.invalid?'disable-btn':'enable-btn'"(click)="onSave()">Save</button>
                }
            </div>
        </div>
    </div>

    <div class="agreement-form-area body-data">
        <div class="agreement-area">
            <form class="form" [formGroup]="carrierForm">
                <table class="form-container" cellspacing="0">
                    <tr >
                        <div class="title" style="display: flex;width: fit-content;">Carrier Details
                            <button *ngIf="operation !== 'add'" class="btn" [ngClass]="dataSource.Status === 'Not Active'?'amber-white-btn':(dataSource.Status === 'Active'?'green-white-btn':'grey-white-btn')">{{dataSource.Status}}</button>
                        </div>
                    </tr>
                    <tr class="accord-area">
                        <div class="input-item"  [ngClass]="this.operation === 'add'?'enable-field':'disable-field'" >
                            <label for='gsdb'  class='required-icon innerLabel'>Contract GSDB</label>
                            <input type='text' name="gsdb" formControlName="gsdb" size='50'
                                placeholder="Enter GSDB" [tabindex]="operation === 'add' ? 1 : -1"/>
                        </div>

                        <div class="input-item" >
                            <label for='name' class='required-icon innerLabel'>Name</label>
                            <input type='text' name="name" formControlName="name" size='50'
                                placeholder="Enter Name" tabindex="1"/>
                        </div>

                        <div class="input-item" >
                            <label for='street' class='innerLabel'>Street</label>
                            <input type='text' name="street" formControlName="street" size='50'
                                placeholder="Enter Street" tabindex="1" />
                        </div>

                        <div class="input-item" >
                            <label for='postcode' class='innerLabel'>Postcode</label>
                            <input type='text' name="postcode" formControlName="postcode" size='50'
                                placeholder="Enter Postcode"  tabindex="1"/>
                        </div>

                        <div class="input-item">
                            <label for='city' class='innerLabel'>City</label>
                            <input type='text' name="city" formControlName="city" size='50'
                                placeholder="Enter City" tabindex="1"/>
                        </div>

                        <div class="input-item">
                            <label for='country'  class='required-icon innerLabel'>Country</label>
                            <select formControlName="country" tabindex="1">
                                <option disabled value="">Select Country</option>
                                <option *ngFor="let option of countryListArr" [value]="option.CountryID" #countryItem>
                                    {{ option.CountryName}} 
                                </option>
                            </select>
                        </div>

                        <div class="input-item">
                            <label for='imcs' class='required-icon innerLabel'>GSDB Site Code</label>
                            <input type='text' name="imcs" formControlName="imcs" size='50'
                                placeholder="Enter GSDB Site Code" tabindex="1"/>
                        </div>

                        <div class="input-item">
                            <label for='vatCode' class='innerLabel'>VAT Code</label>
                            <input type='text' name="vatCode" formControlName="vatCode" size='50'
                                placeholder="Enter VAT Code" tabindex="1"/>
                        </div>

                        <div class="disable-field input-item" (keydown)="onKeyDown($event)">
                            <label for='createdDate' class='innerLabel'>Created (Date/Time)</label>
                            <input type="text" name="createdDate" formControlName="createdDate" size='50'
                                placeholder="Enter Created (Date/Time)" tabindex="-1"/>
                        </div>

                        <div class="disable-field input-item" (keydown)="onKeyDown($event)">
                            <label for='createdBy' class='innerLabel'>Created by</label>
                            <input type='text' name="createdBy" formControlName="createdBy" size='50'
                                placeholder="Enter Created by" tabindex="-1"/>
                        </div>

                        <div class="disable-field input-item" (keydown)="onKeyDown($event)">
                            <label for='modifiedDate' class='innerLabel'>Modified (Date/Time)</label>
                            <input type="text" name="modifiedDate" formControlName="modifiedDate" size='50'
                                placeholder="Enter Modified (Date/Time)" tabindex="-1"/>
                        </div>

                        <div class="disable-field input-item" (keydown)="onKeyDown($event)">
                            <label for='modifiedBy' class='innerLabel'>Modified By</label>
                            <input type='text' name="modifiedBy" formControlName="modifiedBy" size='50'
                                placeholder="Enter Modified By" tabindex="-1"/>
                        </div>
                    </tr>
                </table>
            </form>
        </div>
    </div>
</div>